import React from "react";
import StickyHeadTable from "./StickyHeadTable";
import { useTheme } from "@mui/material/styles";
import { isMobile } from "react-device-detect";
import { Box, Button, Typography } from "@mui/material";
import CommonDialog from "./utils/Dialogs";
import CustomSnackbar from "./utils/Snakbar";
import AdminPickAndSelectMenuInterface from "../interfaces/AdminPickAndSelectMenuInterface";
import { getPaymentMethodLabel } from "./utils/applibs";
import dateFormat from "dateformat";
import PageWrapper from "./layout/PageWrapper";
import RecordsBox from "./RecordsBox";

const AdminMerchants = function (props) {
  const theme = useTheme();

  const styles = {
    root: {
      marginTop: 30,
      border: 0,
      borderRadius: 3,
      boxShadow: "0 3px 5px 2px rgba(95, 85, 87, 0.3)",
      padding: "20px 30px",
    },
    tableCommands: {
      margin: "16px auto",
    },
    panelTableSelection: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "flex-start",
    },
    selection: {
      display: "inline-block",
      marginLeft: 20,
    },
  };

  const {
    merchants: items,
    menus,
    superUser,
    onDelete,
    onEdit,
    onRefreshData,
    onShoppingSnipetRequest,
  } = props;

  const [itemsForSelection, setItemsForSelection] = React.useState([]);
  const [openDialog, setOpenDialog] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState("test");
  const [success, setSuccess] = React.useState(false);

  const handleItemsForSelectionChange = (items) => {
    setItemsForSelection(items);
  };

  const handleClickAssignCategoriesToPlatform = () => {
    setOpenDialog(true);
  };

  const handleDialogClose = (result) => {
    const { message } = result || {};
    setOpenDialog(false);
    if (message) {
      setSnackbarMessage(message);
      setSuccess(true);
    }
  };

  const displayedColumns = [
    { id: "id", label: "#", minWidth: 50, align: "left" },
    { id: "valid", label: "Valid", minWidth: 80 },
    {
      id: "referer",
      label: "Site",
      maxWidth: isMobile ? 120 : 250,
      minWidth: isMobile ? 30 : 50,
    },
    { id: "paymethod", label: "Mode de paiement", minWidth: 150 },
    { id: "currency", label: "Devise", minWidth: 60 },
    { id: "lang", label: "Langue", minWidth: 60 },
    { id: "menu", label: "Menu", minWidth: 80 },
    { id: "created", label: "Ajouté le", minWidth: 60 },
    { id: "action", label: "Actions", minWidth: isMobile ? 90 : 90 },
  ];

  return (
    <PageWrapper>
      <CustomSnackbar
        text={snackbarMessage}
        open={success}
        onCloseSnakbar={() => setSuccess(false)}
      />

      <RecordsBox items={items} itemsForSelection={itemsForSelection} />

      <div style={styles.tableCommands}>
        <Button
          disabled={itemsForSelection.length === 0}
          onClick={handleClickAssignCategoriesToPlatform}
          variant="contained"
        >
          Associer un menu
        </Button>
      </div>

      <CommonDialog
        title="Associer un menu au point de vente"
        onClose={handleDialogClose}
        open={openDialog}
        render={() => (
          <AdminPickAndSelectMenuInterface
            onCancelAction={handleDialogClose}
            callback={handleDialogClose}
            merchants={itemsForSelection}
            menus={menus}
            onPostSave={handleDialogClose}
          />
        )}
      />

      <StickyHeadTable
        superUser={superUser}
        filters={["referer", "currency", "valid", "created", "paymethod"]}
        columns={
          isMobile
            ? displayedColumns.filter(
                (c) => c.id === "referer" || c.id === "action"
              )
            : displayedColumns
        }
        data={items.map((i) => ({
          ...i,
          valid: i.valid === "1" ? "[valid]" : `[invalid (${i.valid})]`,
          paymethod: getPaymentMethodLabel(i.paymethod),
          menu: i.menu || "",
          created: dateFormat(i.created, "mmm dS, H:MM"),
        }))}
        onDelete={onDelete}
        onEdit={onEdit}
        onItemsForSelectionChange={handleItemsForSelectionChange}
        onRefreshData={onRefreshData}
        onShoppingSnipetRequest={onShoppingSnipetRequest}
        checkboxEnabled={true}
      />
    </PageWrapper>
  );
};

export default AdminMerchants;
